import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { buildApproverOption } from '../../utils/approverSelectUtils';
import { ApprovalEditPanelTable } from './ApprovalEditPanelTable';
import { ApprovalEditPanelTooltipI18n } from '../i18n/ApprovalEditPanelTooltipI18n';
import { ApprovalEditPanelSubheadingI18n } from '../i18n/ApprovalEditPanelSubheadingI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ApprovalEditPanelStepOne = ({
  approvedApproverUserIds,
  approversAll,
  changeSelectValue,
  changeCheckbox,
  isLoading,
  selectedApproverIdsMutable,
  superAdminUserIds,
  validApproverOwnerIds
}) => {
  const {
    data
  } = useApprovalContext();
  if (!data) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(Paragraph, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneDescription"
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        help: /*#__PURE__*/_jsx(ApprovalEditPanelSubheadingI18n, {
          approvalType: data.approvalType
        }),
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.approvers"
        }),
        required: true,
        tooltip: /*#__PURE__*/_jsx(ApprovalEditPanelTooltipI18n, {
          approvalType: data.approvalType
        }),
        children: /*#__PURE__*/_jsx(Select, {
          anchorType: "input",
          isLoading: isLoading,
          onChange: changeSelectValue,
          options: approversAll.map(approver => buildApproverOption({
            approver,
            superAdminUserIds,
            approvedApproverUserIds,
            requesterUserId: data.requester.activeUserId
          })),
          "data-test-id": "approval-edit-panel-select",
          multi: true,
          value: [...selectedApproverIdsMutable]
        })
      })]
    }), isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "approval-edit-panel-loading-spinner"
    }) : /*#__PURE__*/_jsx(ApprovalEditPanelTable, {
      approvedApproverUserIds: approvedApproverUserIds,
      approversAll: approversAll,
      changeCheckbox: changeCheckbox,
      selectedApproverIdsMutable: selectedApproverIdsMutable,
      superAdminUserIds: superAdminUserIds,
      validApproverOwnerIds: validApproverOwnerIds
    })]
  });
};